import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const CoManagerDocuments = () => {
  const getAll = data =>
    AuthAxios.get(`${DataApiUrl}/admin/comanager-documents`, { params: data })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getById = id =>
    AuthAxios.get(`${DataApiUrl}/admin/comanager-documents/${id}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const add = data =>
    AuthAxios.post(`${DataApiUrl}/admin/comanager-documents`, data)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const update = (id, data) =>
    AuthAxios.patch(`${DataApiUrl}/admin/comanager-documents/${id}`, data)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const destroy = id =>
    AuthAxios.delete(`${DataApiUrl}/admin/comanager-documents/${id}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  return {
    getAll,
    getById,
    add,
    update,
    destroy,
  };
};

export default CoManagerDocuments;
